import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToCart } from '../redux/actions/cartActions';
import { fetchProductById } from '../redux/actions/productActions';
import { useParams } from 'react-router-dom';
import ProductList from "../components/ProductList";
import Select from 'react-select'

export const Product = () => {

  const dispatch = useDispatch();
  const productId = useParams().id
  const selectedProduct = useSelector((state) => state.products.selectedProduct);

  const [selectedPrice, setSelectedPrice] = useState()

  const products = useSelector((state) => state.products.recommendedProducts); 

  useEffect(() => {
    dispatch(fetchProductById(productId));

    // scroll to top

    window.scrollTo(0, 0);

  }, [dispatch, productId]);

  useEffect(() => {
    window.scrollTo(0, 0);

    setSelectedPrice({
      size: '1kg',
      price: selectedProduct?.price
    })
  }, [])

  const handleAddToCart = (product) => {
    dispatch(addItemToCart({ product, quantity: 1, size: selectedPrice?.size, price: selectedPrice?.price}));
  };

  let options = [
    { value: '1kg', default: true, label: '1kg - ₹' + selectedProduct?.price, price: selectedProduct?.price, size: "1kg" },
    { value: '50gms', label: '500 g - ₹' + selectedProduct?.price / 2,  price: selectedProduct?.price / 2, size: "500gms" },
    { value: '250gms', label: '250 g - ₹' + selectedProduct?.price / 4,  price: selectedProduct?.price / 2, size: "250gms" }
  ]

  return (
    <div className='w-full flex flex-col'>
      <div className='w-full bg-white flex flex-row items-center justify-center p-4'>
        <div className='flex flex-col bg-gray-100 w-[150px] h-[500px] p-3'>
          {selectedProduct?.imageCollection?.map(imageURL => {
            return <img src={imageURL.url} className='w-full h-auto object-cover' alt="" />
          })}
        </div>
        <img src={selectedProduct?.image} className='ml-5 w-[45%] h-[500px] object-cover mb-auto' alt="" />
        <div className='ml-5 flex flex-col items-start w-[calc(55%-150px)] justify-start h-[500px] p-4'>
          <div className='flex flex-row items-center justify-center w-full mb-3'>
            <div className='flex flex-col items-start justify-start'>
              <div className='text-3xl font-bold'>{selectedProduct?.name}</div>
              <div className='text-lg text-primary font-normal'>[&nbsp;{selectedProduct?.brand}&nbsp;]</div>
            </div>
            <p className='bg-emerald-200 ml-auto p-2 px-3 rounded-full text-sm'> ₹ {selectedProduct?.price} /kg</p>
          </div>
          <div className='text-lg font-normal mb-2 mt-2'>{selectedProduct?.description}</div>

          <div className='h-[2px] w-full my-6 bg-gray-100'></div>

          <p className='text-lg mb-4'>Select Size of the package</p>
          {selectedProduct && 
            <Select className='w-full z-[9] relative' options={options} defaultValue={{ value: '1kg', default: true, label: '1kg - ₹' + selectedProduct?.price }} onChange = {value => {
              setSelectedPrice(value)
            }}
            />
          }

          {selectedPrice && <p className='text-3xl my-5 mt-7'>₹{selectedPrice?.price || selectedProduct?.price}</p>}
          <button onClick={() => handleAddToCart(selectedProduct)} className='bg-primary text-white text-md font-semibold mt-1 py-2 px-5 rounded-md'>Add to Cart</button>
        </div>
      </div>

      <div className="mt-[60px] text-3xl font-bold flex flex-row gap-[40px] items-center justify-center mr-auto">
        Recommended Products
      </div>

      <svg class="w-[100px] h-auto mt-[20px] mb-[40px] mr-auto" viewBox="0 0 229 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19" stroke="currentColor" stroke-opacity="0.2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1" stroke="#9D9D9D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <ProductList products={products} />
      
      <div className="h-[50px] w-full"></div>

    </div>
  )
}